/** Participant-safe projection. Other participants' identities and picks never leave the server. */
export interface SportsChallengeView {
  id: string;
  rulesHash: string;
  rules: string;
  homeTeam: string;
  awayTeam: string;
  lockAt: number;
  serverNow: number;
  active: boolean;
  status: 'open' | 'locked' | 'settled' | 'void' | 'result_held';
  entries: number;
  ownReceipt: {
    pick: 'home' | 'away';
    acceptedAt: number;
    receiptId: string;
    points: number | null;
  } | null;
  result: {
    revision: number;
    homePoints: number | null;
    awayPoints: number | null;
    observedAt: number;
    reason: string;
  } | null;
}
export type SportsChallengeRequest =
  | { operation: 'read'; roomId: string; lastChallengeId?: string }
  | {
      operation: 'pick';
      roomId: string;
      requestId: string;
      challengeId: string;
      rulesHash: string;
      pick: 'home' | 'away';
      rulesAccepted: true;
    }
  | { operation: 'end'; roomId: string; requestId: string; challengeId: string; rulesHash: string };
export type SportsChallengeReply =
  | { ok: true; view: SportsChallengeView | null; message?: string }
  | { ok: false; reason: 'rejected' | 'unavailable'; message?: string };
export const SPORTS_CHALLENGE_REQUEST = 'sports-challenge:request';
export const SPORTS_CHALLENGE_CHANGED = 'sports-challenge:changed';
